// src/services/visitor.js

/**
 * Genere ou recupere l'identifiant navigateur.
 * Retourne null si le stockage local est indisponible.
 */
export function getVisitorId() {
  try {
    let visitorId = localStorage.getItem("visitorId");
    if (!visitorId) {
      visitorId = crypto?.randomUUID?.() || generateUUID();
      localStorage.setItem("visitorId", visitorId);
    }
    return visitorId;
  } catch (e) {
    console.warn("LocalStorage indisponible, visitorId non persiste.");
    return null;
  }
}

function generateUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
